<template>
  <ObjectiveBuilder v-if="isObjective" :type="type" />
  <FundsBuilder
    v-else
    :ask-for-investor-type="askForInvestorType"
    :type="type"
  />
</template>

<script lang="ts" setup>
import { computed } from 'vue';
import { useRoute } from 'vue-router/composables';

import { FundsBuilder } from './views/FundsBuilder';
import { ObjectiveBuilder } from './views/ObjectiveBuilder';

const route = useRoute();

const type = computed(() => {
  return route.params.type as string;
});

const isObjective = computed(() => {
  return type.value === 'objective';
});

const askForInvestorType = computed(() => {
  return Boolean(route.query?.qualifiedInvestor);
});
</script>
